import { mapActions, mapState } from "vuex";

export const addLessonContentMixins = {
  data() {
    return {
      form: {
        lessonContentTemplate: {
          version: null,
          contentType: "",
          material: {
            audioText: "",
            displayAudioText: "",
            audioSsmlText: "",
            filename: "",
            markFlag: null,
            markUuid: null,
            id: null,
            materialId: null,
            duration: null,
            materialUrl: "",
            type: "",
            voice: "",
            speechRate: "",
          },
          materials: [
            {
              audioText: "",
              displayAudioText: "",
              audioSsmlText: "",
              filename: "",
              materialId: null,
              duration: null,
              materialUrl: "",
              type: "",
              voice: "",
              speechRate: "",
            },
            {
              audioText: "",
              displayAudioText: "",
              audioSsmlText: "",
              filename: "",
              materialId: null,
              duration: null,
              materialUrl: "",
              type: "",
            },
            {
              audioText: "",
              displayAudioText: "",
              audioSsmlText: "",
              filename: "",
              materialId: null,
              duration: null,
              materialUrl: "",
              type: "",
            },
            {
              audioText: "",
              displayAudioText: "",
              audioSsmlText: "",
              filename: "",
              materialId: null,
              duration: null,
              materialUrl: "",
              type: "",
              voice: "",
              speechRate: "",
            },
          ],
          question: {
            answer: [],
            displayExplain: "",
            explain: "",
            explainAudio: "",
            explainAudioType: "",
            item: [], // list string
            itemType: "",
            title: "",
            titleAudio: "",
            titleAudioType: "",
            type: "select",
            titles: [], // list map
          },
          role: "",
          text: {
            item: [],
            itemType: "",
          },
        },
        lessonId: null,
        model: "",
        modelId: null,
        operateOffset: null,
        role: "",
        type: "",
        version: null,
        sortTrueAnswer: null
      },
      formData: {
        lessonContentTemplate: {
          version: null,
          contentType: "",
          material: {
            audioText: "",
            displayAudioText: "",
            audioSsmlText: "",
            filename: "",
            markFlag: null,
            markUuid: null,
            id: null,
            materialId: null,
            duration: null,
            materialUrl: "",
            type: "",
          },
          materials: [
            {
              audioText: "",
              displayAudioText: "",
              audioSsmlText: "",
              filename: "",
              materialId: null,
              duration: null,
              materialUrl: "",
              type: "",
            },
            {
              audioText: "",
              displayAudioText: "",
              audioSsmlText: "",
              filename: "",
              materialId: null,
              duration: null,
              materialUrl: "",
              type: "",
            },
            {
              audioText: "",
              displayAudioText: "",
              audioSsmlText: "",
              filename: "",
              materialId: null,
              duration: null,
              materialUrl: "",
              type: "",
            },
            {
              audioText: "",
              displayAudioText: "",
              audioSsmlText: "",
              filename: "",
              materialId: null,
              duration: null,
              materialUrl: "",
              type: "",
            },
          ],
          question: {
            answer: [],
            displayExplain: "",
            explain: "",
            explainAudio: "",
            explainAudioType: "",
            item: [], // list string
            itemType: "",
            title: "",
            titleAudio: "",
            titleAudioType: "",
            type: "select",
            titles: [], // list map
          },
          role: "",
          text: {
            item: [],
            itemType: "",
          },
        },
        lessonId: null,
        model: "",
        modelId: null,
        role: "",
        type: "",
        version: null,
        operateOffset: null,
        sortTrueAnswer: null
      },
      isRequiredSort: false,
      rules: {
        role: [
          {
            required: true,
            message: "请选择",
            trigger: ["blur"],
          },
        ],
        type: [
          {
            required: true,
            message: "请选择",
            trigger: ["blur"],
          },
        ],
        "lessonContentTemplate.material.audioText": [
          {
            pattern: /^[\s\S]{0,300}$/,
            message: "不得超过300字",
            trigger: ["blur", "change"],
          },
        ],
        "lessonContentTemplate.materials[0].audioText": [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[\s\S]{0,300}$/,
            message: "不得超过300字",
            trigger: ["blur", "change"],
          },
        ],
        "lessonContentTemplate.material.displayAudioText": [
          {
            required: true,
            message: "请清除框内空格",
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value && value.trim().length === 0) {
                callback(new Error("请清除框内空格"));
              } else {
                callback();
              }
            },
          },
          {
            pattern: /^[\s\S]{0,1000}$/,
            message: "不得超过1000字",
            trigger: ["blur", "change"],
          },
        ],
        "lessonContentTemplate.materials[3].audioText": [
          {
            pattern: /^[\s\S]{0,300}$/,
            message: "转音频文字不得超过300字",
            trigger: ["blur", "change"],
          },
        ],
        "lessonContentTemplate.question.item[0]": [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (!value || (value && value.trim().length === 0)) {
                callback(new Error("请输入"));
              } else {
                callback();
              }
            },
          },
        ],
        "lessonContentTemplate.question.item[1]": [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (!value || (value && value.trim().length === 0)) {
                callback(new Error("请输入"));
              } else {
                callback();
              }
            },
          },
        ],
        "lessonContentTemplate.question.item[2]": [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (!value || (value && value.trim().length === 0)) {
                callback(new Error("请输入"));
              } else {
                callback();
              }
            },
          },
        ],
        "lessonContentTemplate.question.answer[0]": [
          {
            required: true,
            message: "请选择",
            trigger: ["blur", "change"],
          },
        ],
        "lessonContentTemplate.text.item[0]": [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        "lessonContentTemplate.question.title": [
          {
            required: true,
            message: "请清除框内空格",
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value && value.trim().length === 0) {
                callback(new Error("请清除框内空格"));
              } else {
                callback();
              }
            },
          },
          {
            pattern: /^[\s\S]{0,110}$/,
            message: "不得超过110字",
            trigger: ["blur", "change"],
          },
        ],
        upload: [
          {
            required: true,
            message: "请上传",
            trigger: ["blur"],
          },
        ],
        "lessonContentTemplate.question.displayExplain": [
          {
            required: true,
            message: "请输入",
            trigger: ["blur"],
          },
          {
            pattern: /^[\s\S]{0,140}$/,
            message: "不得超过140字",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("courseCenter", ["editOutLineDetail"]),
  },
  methods: {
    ...mapActions("courseCenter", [
      "saveLessonContent",
      "addBelowLessonContent",
    ]),
    //表单清空
    clearForm() {
      this.formData = JSON.parse(JSON.stringify(this.form));
      this.videoUrl = "";
      this.imageUrl = "";
      this.imageSelectUrlA = "";
      this.imageSelectUrlB = "";
      this.isRequiredSort = false;
      this.type = "";
      this.blankWarning = false;
      this.inputValArr = [];
      this.sortTrueAnswer = null;
    },
    async handleCommit() {
      console.log("handleCommit");
      var result = true;
      this.formData.lessonContentTemplate.contentType = this.formData.type;
      this.formData.lessonContentTemplate.role = this.formData.role;
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          //文本转语音
          if (this.formData.type === "audioText") {
            this.formData.lessonContentTemplate.materials = [];
            if (
              !this.formData.lessonContentTemplate.material.displayAudioText &&
              !this.formData.lessonContentTemplate.material.audioText
            ) {
              this.$message.warning("内容不可为空，请至少填写一项后继续操作!");
              return (result = false);
            }
            if (
              this.formData.lessonContentTemplate.material.audioText &&
              !this.formData.lessonContentTemplate.material.materialUrl
            ) {
              this.$message.warning("当前题干未生成音频，请生成音频后继续操作");
              return (result = false);
            }

            const audioText = this.convertToObjects(
              this.formData.lessonContentTemplate.material.audioText
            );
            const audioSsmlText = this.creatSsmlText(
              this.formData.lessonContentTemplate.material.audioText
            );
            if (
              this.formData.lessonContentTemplate.material.materialUrl &&
              audioText.length < 1 &&
              audioSsmlText !==
                this.formData.lessonContentTemplate.material.audioSsmlText
            ) {
              this.$confirm(
                "你已对音频文字进行了删除操作,请选择是否要同步清除音频!",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  closeOnClickModal: false,
                }
              )
                .then(async () => {
                  this.formData.lessonContentTemplate.material.materialUrl = "";
                  this.formData.lessonContentTemplate.material.materialId =
                    null;
                  this.formData.lessonContentTemplate.material.duration = null;
                  this.formData.lessonContentTemplate.material.filename = "";
                  this.formData.lessonContentTemplate.material.audioText = "";
                  this.formData.lessonContentTemplate.material.audioSsmlText =
                    "";
                  if (this.formData.role === "学生") {
                    this.defaultVoiceMethod("zhigui");
                  } else {
                    this.defaultVoiceMethod("zhiyuan");
                  }
                })
                .catch(() => {
                  this.formData.lessonContentTemplate.material.audioSsmlText =
                    audioSsmlText;
                });
              return (result = false);
            }
            if (audioText.length > 300) {
              return (result = false);
            }
            if (
              audioSsmlText !==
              this.formData.lessonContentTemplate.material.audioSsmlText
            ) {
              this.$confirm(
                "你已对音频文字进行了修改,请确认是否重新生成音频!",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  closeOnClickModal: false,
                }
              )
                .then(async () => {
                  await this.handleTitleAudio();
                })
                .catch(() => {
                  this.formData.lessonContentTemplate.material.audioSsmlText =
                    audioSsmlText;
                });
              return (result = false);
            }
          }
          //视频
          if (this.formData.type === "video") {
            // this.formData.lessonContentTemplate.materials = [];
            if (!this.videoUrl) {
              this.$message.warning("请上传视频");
              return (result = false);
            }
          }
          //判断、排序
          if (
            this.formData.type === "judge" ||
            this.formData.type === "imageSelect" ||
            this.formData.type === "select" ||
            this.formData.type === "multipleSelect" ||
            this.formData.type === "text" ||
            this.formData.type === "sort"
          ) {
            if (this.isSituational && this.$refs.explainEdit.warning) {
              return (result = false);
            }
            const questionTitle =
              this.formData.lessonContentTemplate.question.title;
            const audioText = this.convertToObjects(
              this.formData.lessonContentTemplate.materials[0].audioText
            );

            if (
              (!questionTitle || questionTitle.trim().length === 0) &&
              audioText.length < 1
            ) {
              this.$message.warning("请添加题干后重试");
              result = false;
            }

            if (
              this.formData.lessonContentTemplate.question.titleAudio &&
              audioText.length > 300
            ) {
              this.blankWarning = true;
              return (result = false);
            }
            if (
              audioText.length < 1 &&
              this.formData.lessonContentTemplate.materials[0].materialUrl
            ) {
              this.$confirm(
                "你已对音频文字进行了删除操作,请选择是否要同步清除音频!",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  closeOnClickModal: false,
                }
              )
                .then(async () => {
                  this.formData.lessonContentTemplate.materials[0].materialUrl =
                    "";
                  this.formData.lessonContentTemplate.materials[0].audioText =
                    "";
                  this.formData.lessonContentTemplate.materials[0].audioSsmlText =
                    "";
                  this.formData.lessonContentTemplate.materials[0].filename =
                    "";
                  this.formData.lessonContentTemplate.materials[0].materialId =
                    null;
                  this.formData.lessonContentTemplate.materials[0].duration =
                    null;
                  if (this.formData.role === "学生") {
                    this.defaultVoiceMethod("zhigui");
                  } else {
                    this.defaultVoiceMethod("zhiyuan");
                  }
                })
                .catch(() => {
                  this.formData.lessonContentTemplate.materials[0].audioSsmlText =
                    "";
                });
              return (result = false);
            }
            if (
              this.formData.lessonContentTemplate.materials[0].audioText &&
              !this.formData.lessonContentTemplate.materials[0].materialUrl
            ) {
              this.$message.warning("当前题干未生成音频，请生成音频后继续操作");
              return (result = false);
            }
            const audioSsmlText = this.creatSsmlText(
              this.formData.lessonContentTemplate.materials[0].audioText
            );
            if (
              audioSsmlText !==
              this.formData.lessonContentTemplate.materials[0].audioSsmlText
            ) {
              this.$confirm(
                "你已对音频文字进行了修改,请确认是否重新生成音频!",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  closeOnClickModal: false,
                }
              )
                .then(async () => {
                  await this.handleGroupTitleAudio();
                })
                .catch(() => {
                  this.formData.lessonContentTemplate.materials[0].audioSsmlText =
                    audioSsmlText;
                });
              return (result = false);
            }
          }
          // 选择
          if (this.formData.type === "select") {
            if (
              (!this.formData.lessonContentTemplate.question.item[2] &&
                this.formData.lessonContentTemplate.question.item[3]) ||
              (this.formData.lessonContentTemplate.question.item[2] &&
                this.formData.lessonContentTemplate.question.item[2].length ===
                  0 &&
                this.formData.lessonContentTemplate.question.item[3])
            ) {
              this.$confirm("请依序填写选项内容，修改后重试!", "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              })
                .then(async () => {})
                .catch(() => {});
              return (result = false);
            }
            this.formData.lessonContentTemplate.question.item =
              this.formData.lessonContentTemplate.question.item.filter(
                (item) => item && item.trim().length !== 0
              );
          }
          // 多选
          if (this.formData.type === "multipleSelect") {
            if (
              this.formData.lessonContentTemplate.question.answer.length < 2
            ) {
              this.$message.warning("请至少选择两个选项后重试!");
              return (result = false);
            }
            this.formData.lessonContentTemplate.question.answer.sort();
            this.formData.lessonContentTemplate.question.item.forEach(
              (item, index) => {
                if (item && item.trim().length === 0) {
                  this.formData.lessonContentTemplate.question.item[index] =
                    null;
                }
              }
            );
          }
          // 排序
          if (this.formData.type === "sort") {
            // if (
            //   (!this.formData.lessonContentTemplate.question.item[3] &&
            //     this.formData.lessonContentTemplate.question.item[4]) ||
            //   (this.formData.lessonContentTemplate.question.item[3] &&
            //     this.formData.lessonContentTemplate.question.item[3].length ===
            //       0 &&
            //     this.formData.lessonContentTemplate.question.item[4])
            // ) {
            //   this.$confirm("请按顺序添加排序选项内容后重新提交!", "提示", {
            //     confirmButtonText: "确定",
            //     showCancelButton: false,
            //     type: "warning",
            //   })
            //     .then(async () => {})
            //     .catch(() => {});
            //   return (result = false);
            // }
            this.formData.lessonContentTemplate.question.item =
              this.formData.lessonContentTemplate.question.item.filter(
                (item) => item && item.trim().length !== 0
              );
            if (this.sortTrueAnswer) {
              let arr = this.sortTrueAnswer.toString().split("");
              let len =
                this.formData.lessonContentTemplate.question.item.length;
              if (arr.length !== len) {
                this.$confirm("正确顺序输入有误，请修改后重新提交!", "提示", {
                  confirmButtonText: "确定",
                  showCancelButton: false,
                  type: "warning",
                })
                  .then(async () => {})
                  .catch(() => {});
                return (result = false);
              } else if (new Set(arr).size !== arr.length) {
                this.$confirm("正确顺序输入有误，请修改后重新提交!", "提示", {
                  confirmButtonText: "确定",
                  showCancelButton: false,
                  type: "warning",
                })
                  .then(async () => {})
                  .catch(() => {});
                return (result = false);
              } else if (arr.some((num) => num < 1 || num > len)) {
                this.$confirm("正确顺序输入有误，请修改后重新提交!", "提示", {
                  confirmButtonText: "确定",
                  showCancelButton: false,
                  type: "warning",
                })
                  .then(async () => {})
                  .catch(() => {});
                return (result = false);
              }
            } else {
              this.isRequiredSort = true;
              return (result = false);
            }
            this.formData.lessonContentTemplate.question.answer =
              this.sortTrueAnswer.toString().split("");
          }
          //图片
          if (this.formData.type === "image") {
            // this.formData.lessonContentTemplate.materials = []
            if (!this.imageUrl) {
              this.$message.warning("请上传图片");
              return (result = false);
            }
          }
          //聊天框选择
          if (this.formData.type === "dialogSelect") {
            this.formData.lessonContentTemplate.materials = [];
          }
          //文本框
          if (this.formData.type === "text") {
            this.formData.lessonContentTemplate.text.itemType = "text";
          }
          //富文本框
          if (this.formData.type === "richText") {
            this.formData.lessonContentTemplate.role = "老师";
            this.formData.role = "老师";
            if (
              !this.imageUrl &&
              !this.formData.lessonContentTemplate.text.item[0]
            ) {
              this.$message.warning("内容不可为空，请至少填写一项后继续操作!");
              return (result = false);
            }
            this.formData.lessonContentTemplate.text.itemType = "text";
          }
        }
      });
      return result;
    },
    async handleCommitV2() {
      console.log("handleCommitV2");
      var result = true;
      this.formData.lessonContentTemplate.role = this.formData.role;
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.formData.lessonContentType == "content") {
            //文本转语音
            if (this.formData.contentPattern === "audioText") {
              this.formData.lessonContentTemplate.materials = [];
              if (
                !this.formData.lessonContentTemplate.material
                  .displayAudioText &&
                !this.formData.lessonContentTemplate.material.audioText
              ) {
                this.$message.warning(
                  "内容不可为空，请至少填写一项后继续操作!"
                );
                return (result = false);
              }
              if (
                this.formData.lessonContentTemplate.material.audioText &&
                !this.formData.lessonContentTemplate.material.materialUrl
              ) {
                this.$message.warning(
                  "当前题干未生成音频，请生成音频后继续操作"
                );
                return (result = false);
              }

              const audioText = this.convertToObjects(
                this.formData.lessonContentTemplate.material.audioText
              );
              const audioSsmlText = this.creatSsmlText(
                this.formData.lessonContentTemplate.material.audioText
              );
              if (
                this.formData.lessonContentTemplate.material.materialUrl &&
                audioText.length < 1 &&
                audioSsmlText !==
                  this.formData.lessonContentTemplate.material.audioSsmlText
              ) {
                this.$confirm(
                  "你已对音频文字进行了删除操作,请选择是否要同步清除音频!",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    closeOnClickModal: false,
                  }
                )
                  .then(async () => {
                    this.formData.lessonContentTemplate.material.materialUrl =
                      "";
                    this.formData.lessonContentTemplate.material.materialId =
                      null;
                    this.formData.lessonContentTemplate.material.duration =
                      null;
                    this.formData.lessonContentTemplate.material.filename = "";
                    this.formData.lessonContentTemplate.material.audioText = "";
                    this.formData.lessonContentTemplate.material.audioSsmlText =
                      "";
                    if (this.formData.role === "学生") {
                      this.defaultVoiceMethod("zhigui");
                    } else {
                      this.defaultVoiceMethod("zhiyuan");
                    }
                  })
                  .catch(() => {
                    this.formData.lessonContentTemplate.material.audioSsmlText =
                      audioSsmlText;
                  });
                return (result = false);
              }
              if (audioText.length > 300) {
                return (result = false);
              }
              if (
                audioSsmlText !==
                this.formData.lessonContentTemplate.material.audioSsmlText
              ) {
                this.$confirm(
                  "你已对音频文字进行了修改,请确认是否重新生成音频!",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    closeOnClickModal: false,
                  }
                )
                  .then(async () => {
                    await this.handleTitleAudio();
                  })
                  .catch(() => {
                    this.formData.lessonContentTemplate.material.audioSsmlText =
                      audioSsmlText;
                  });
                return (result = false);
              }
            }
            //视频
            else if (this.formData.contentPattern === "video") {
              // this.formData.lessonContentTemplate.materials = [];
              if (!this.formData.videoUrl) {
                this.$message.warning("请上传视频");
                return (result = false);
              }
            }
            //音频
            else if (this.formData.contentPattern === "audio") {
              // this.formData.lessonContentTemplate.materials = [];
              if (!this.formData.audioUrl) {
                this.$message.warning("请上传音频");
                return (result = false);
              }
            }
            //图片
            else if (this.formData.contentPattern === "image") {
              // this.formData.lessonContentTemplate.materials = [];
              if (!this.formData.imageUrl) {
                this.$message.warning("请上传图片");
                return (result = false);
              }
            }
          } else {
            //判断、排序
            if (
              this.formData.type === "judge" ||
              this.formData.type === "imageSelect" ||
              this.formData.type === "select" ||
              this.formData.type === "multipleSelect" ||
              this.formData.type === "text" ||
              this.formData.type === "sort"
            ) {
              if (this.isSituational && this.$refs.explainEdit.warning) {
                return (result = false);
              }
              const questionTitle =
                this.formData.lessonContentTemplate.question.title;
              const audioText = this.convertToObjects(
                this.formData.lessonContentTemplate.materials[0].audioText
              );

              if (
                (!questionTitle || questionTitle.trim().length === 0) &&
                audioText.length < 1
              ) {
                this.$message.warning("请添加题干后重试");
                result = false;
              }

              if (
                this.formData.lessonContentTemplate.question.titleAudio &&
                audioText.length > 300
              ) {
                this.blankWarning = true;
                return (result = false);
              }
              if (
                audioText.length < 1 &&
                this.formData.lessonContentTemplate.materials[0].materialUrl
              ) {
                this.$confirm(
                  "你已对音频文字进行了删除操作,请选择是否要同步清除音频!",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    closeOnClickModal: false,
                  }
                )
                  .then(async () => {
                    this.formData.lessonContentTemplate.materials[0].materialUrl =
                      "";
                    this.formData.lessonContentTemplate.materials[0].audioText =
                      "";
                    this.formData.lessonContentTemplate.materials[0].audioSsmlText =
                      "";
                    this.formData.lessonContentTemplate.materials[0].filename =
                      "";
                    this.formData.lessonContentTemplate.materials[0].materialId =
                      null;
                    this.formData.lessonContentTemplate.materials[0].duration =
                      null;
                    if (this.formData.role === "学生") {
                      this.defaultVoiceMethod("zhigui");
                    } else {
                      this.defaultVoiceMethod("zhiyuan");
                    }
                  })
                  .catch(() => {
                    this.formData.lessonContentTemplate.materials[0].audioSsmlText =
                      "";
                  });
                return (result = false);
              }
              if (
                this.formData.lessonContentTemplate.materials[0].audioText &&
                !this.formData.lessonContentTemplate.materials[0].materialUrl
              ) {
                this.$message.warning(
                  "当前题干未生成音频，请生成音频后继续操作"
                );
                return (result = false);
              }
              const audioSsmlText = this.creatSsmlText(
                this.formData.lessonContentTemplate.materials[0].audioText
              );
              if (
                audioSsmlText !==
                this.formData.lessonContentTemplate.materials[0].audioSsmlText
              ) {
                this.$confirm(
                  "你已对音频文字进行了修改,请确认是否重新生成音频!",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    closeOnClickModal: false,
                  }
                )
                  .then(async () => {
                    await this.handleGroupTitleAudio();
                  })
                  .catch(() => {
                    this.formData.lessonContentTemplate.materials[0].audioSsmlText =
                      audioSsmlText;
                  });
                return (result = false);
              }
            }
            // 选择
            if (this.formData.type === "select") {
              if (
                (!this.formData.lessonContentTemplate.question.item[2] &&
                  this.formData.lessonContentTemplate.question.item[3]) ||
                (this.formData.lessonContentTemplate.question.item[2] &&
                  this.formData.lessonContentTemplate.question.item[2]
                    .length === 0 &&
                  this.formData.lessonContentTemplate.question.item[3])
              ) {
                this.$confirm("请依序填写选项内容，修改后重试!", "提示", {
                  confirmButtonText: "确定",
                  showCancelButton: false,
                  type: "warning",
                })
                  .then(async () => {})
                  .catch(() => {});
                return (result = false);
              }
              this.formData.lessonContentTemplate.question.item =
                this.formData.lessonContentTemplate.question.item.filter(
                  (item) => item && item.trim().length !== 0
                );
            }
            // 多选
            if (this.formData.type === "multipleSelect") {
              if (
                this.formData.lessonContentTemplate.question.answer.length < 2
              ) {
                this.$message.warning("请至少选择两个选项后重试!");
                return (result = false);
              }
              this.formData.lessonContentTemplate.question.answer.sort();
              this.formData.lessonContentTemplate.question.item.forEach(
                (item, index) => {
                  if (item && item.trim().length === 0) {
                    this.formData.lessonContentTemplate.question.item[index] =
                      null;
                  }
                }
              );
            }
            // 排序
            if (this.formData.lessonContentTemplate.question.type === "sort") {
              this.formData.lessonContentTemplate.question.item =
                this.formData.lessonContentTemplate.question.item.filter(
                  (item) => item && item.trim().length !== 0
                );
              if (this.formData.sortTrueAnswer) {
                let arr = this.formData.sortTrueAnswer.toString().split(",");
                let len =
                  this.formData.lessonContentTemplate.question.item.length;
                if (arr.length !== len) {
                  this.$confirm("正确顺序输入有误，请修改后重新提交!", "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "warning",
                  })
                    .then(async () => {})
                    .catch(() => {});
                  return (result = false);
                } else if (new Set(arr).size !== arr.length) {
                  this.$confirm("正确顺序输入有误，请修改后重新提交!", "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "warning",
                  })
                    .then(async () => {})
                    .catch(() => {});
                  return (result = false);
                } else if (arr.some((num) => num < 1 || num > len)) {
                  this.$confirm("正确顺序输入有误，请修改后重新提交!", "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "warning",
                  })
                    .then(async () => {})
                    .catch(() => {});
                  return (result = false);
                }
              } else {
                this.isRequiredSort = true;
                return (result = false);
              }
              this.formData.lessonContentTemplate.question.answer =
                this.formData.sortTrueAnswer.toString().split(",");
            }
            //图片
            if (this.formData.type === "image") {
              // this.formData.lessonContentTemplate.materials = []
              if (!this.imageUrl) {
                this.$message.warning("请上传图片");
                return (result = false);
              }
            }
            //聊天框选择
            if (this.formData.type === "dialogSelect") {
              this.formData.lessonContentTemplate.materials = [];
            }
            //文本框
            if (this.formData.type === "text") {
              this.formData.lessonContentTemplate.text.itemType = "text";
            }
            //富文本框
            if (this.formData.type === "richText") {
              this.formData.lessonContentTemplate.role = "老师";
              this.formData.role = "老师";
              if (
                !this.imageUrl &&
                !this.formData.lessonContentTemplate.text.item[0]
              ) {
                this.$message.warning(
                  "内容不可为空，请至少填写一项后继续操作!"
                );
                return (result = false);
              }
              this.formData.lessonContentTemplate.text.itemType = "text";
            }
          }
        }
      });
      return result;
    },
  },
};
